import { AccountGroupDropdownData, UsersSearchDropdownData } from "../../../../Utils/AllPagesQuriesAndMutations";

export const data = [
  {
    name: "VerticalSection",
    section: "CustomerAccount",
    ValidationName: "VerticalSection1",
    sections: [
      {
        name: "Business_Details",
        VerticalSection: true,
        fields: [
          {
            id: Math.random() * 10,
            name: "Business_Name",
            label: "Business Name",
            type: "text",
            isRequired: true,
            FirstCharCap: true,
            min: 0,
            max: Infinity,
          },
          {
            id: Math.random() * 10,
            name: "Business_Type",
            label: "Business Type",
            type: "inputdrop",
            dropdowncontent: [
              "Manufacturer",
              "Trader",
              "Agri Trader",
              "Service Provider",
              "Transporter",
              "Fleet Owner",
              "commission Agent (Broker)",
              "Custom House Agent (CHA)",
              "Importer",
              "Exporter",
            ],
          },
          {
            id: Math.random() * 10,
            name: "Business_Address",
            label: "Business Address",
            type: "textarea",
            FirstCharCap: true,
            min: 0,
            max: Infinity,
          },

          {
            id: Math.random() * 10,
            name: "Business_Pincode",
            label: "Pincode",
            type: "number",
            min: 6,
            max: 6,
            ValidationType: "VALID_NUMBER",
          },
          {
            id: Math.random() * 10,
            name: "Sidebyside",
            Subfields: [
              {
                id: Math.random() * 10,
                name: "Business_City",
                label: "City",
                setvalue: "City",
                // disable: true,
                type: "text",
                min: 0,
                max: Infinity,
              },
              {
                id: Math.random() * 10,
                name: "Business_State",
                label: "State",
                // disable: true,
                setvalue: "State",
                type: "text",
                min: 0,
                max: Infinity,
              },
            ],
          },
          {
            id: Math.random() * 10,
            name: "Sidebyside",
            Subfields: [
              {
                id: Math.random() * 10,
                name: "Business_Mobile_Number",
                label: "Mobile No",
                type: "number",
                min: 10,
                max: 10,
                // isRequired: true,
                ValidationType: "VALID_NUMBER",
              },
              {
                id: Math.random() * 10,
                name: "Land_Line",
                label: "Land Line",
                type: "number",
                min: 11,
                max: 11,
              },
            ],
          },
          {
            id: Math.random() * 10,
            name: "Email",
            label: "Email",
            type: "text",
            min: 0,
            max: Infinity,
            ValidationType: "EMAIL",
          },
          {
            id: Math.random() * 10,
            name: "GST_Number",
            label: "GST Number",
            type: "text",
            min: 15,
            max: 15,
            AllCaps: true,
            ValidationType: "GST",
          },
          {
            id: Math.random() * 10,
            name: "Business_Pan",
            label: "Business PAN ",
            type: "text",
            min: 10,
            max: 10,
            AllCaps: true,
            ValidationType: "PAN",
          },
          {
            id: Math.random() * 10,
            name: "Account_Manager",
            label: "Account Manager",
            type: "InputDropForQuery",
            masterName: "User_Entry",
            dropdowndata: UsersSearchDropdownData,
          },
        ],
      },
      {
        name: "Account_Details",
        VerticalSection: true,
        fields: [
          {
            id: Math.random() * 10,
            name: "IFSC_Code",
            label: "IFSC Code",
            type: "text",
            min: 11,
            max: 11,
            AllCaps: true,
            ValidationType: "IFSC",
          },
          {
            id: Math.random() * 10,
            name: "Account_Number",
            label: "Account Number",
            type: "text",
            min: 9,
            max: 20,
            ValidationType: "VALID_NUMBER",
          },
        ],
      },
    ],
  },
  {
    name: "VerticalSection",
    ValidationName: "VerticalSection2",
    sections: [
      {
        name: "Proprieter_Details",
        VerticalSection: true,
        fields: [
          {
            id: Math.random() * 10,
            name: "Proprietor_Name",
            label: "Proprietor Name (As Per Adhar)",
            type: "text",
            FirstCharCap: true,
            min: 0,
            max: Infinity,

            ValidationType: "VALID_STRING",
          },
          {
            id: Math.random() * 10,
            name: "Residential_Address",
            label: "Residential Address",
            type: "textarea",
            FirstCharCap: true,
            min: 0,
            max: Infinity,
          },
          {
            id: Math.random() * 10,
            name: "Residential_Pincode",
            type: "number",
            min: 6,
            max: 6,
            ValidationType: "VALID_NUMBER",
          },
          {
            id: Math.random() * 10,
            name: "Sidebyside",
            Subfields: [
              {
                id: Math.random() * 10,
                name: "Residential_City",
                label: "City",
                setvalue: "City",
                // disable: true,
                type: "text",
                min: 0,
                max: Infinity,
              },
              {
                id: Math.random() * 10,
                name: "Residential_State",
                label: "State",
                setvalue: "State",
                // disable: true,
                type: "text",
                min: 0,
                max: Infinity,
              },
            ],
          },
          {
            id: Math.random() * 10,
            name: "Sidebyside",
            Subfields: [
              {
                id: Math.random() * 10,
                name: "Mobile_Number",
                label: "Mobile Number",
                type: "number",
                min: 10,
                max: 10,

                ValidationType: "VALID_STRING",
              },
              {
                id: Math.random() * 10,
                name: "Land_Line",
                label: "Land Line",
                type: "number",
                min: 11,
                max: 11,
              },
            ],
          },
          {
            id: Math.random() * 10,
            name: "Aadhar_Number",
            label: "Aadhar Number",
            type: "inputMask",
            mask: "9999-9999-9999",
            min: 12,
            max: 12,
            ValidationType: "AADHAAR",
          },
          {
            id: Math.random() * 10,
            name: "Pan_Number",
            label: "Pan Number",
            type: "text",
            min: 10,
            max: 10,
            AllCaps: true,
            ValidationType: "PAN",
          },
          {
            id: Math.random() * 10,
            name: "Account_Group",
            label: "Account Group ",
            type: "InputDropForQuery",
            masterName: "Account_Group",
            dropdowndata: AccountGroupDropdownData,
          },
          {
            id: Math.random() * 10,
            name: "Description",
            label: "Narration",
            type: "textarea",
            FirstCharCap: true,
            min: 0,
            max: Infinity,
          },
        ],
      },
      {
        name: "Balance_Details",
        VerticalSection: true,
        fields: [
          {
            id: Math.random() * 10,
            name: "Balance_Method",
            label: "Balance_Method",
            type: "inputdrop",
            dropdowncontent: ["Balance Only", "Bill By Bill"],
          },
          {
            id: Math.random() * 10,
            name: "Sidebyside",
            Subfields: [
              {
                id: Math.random() * 10,
                name: "Opening_Balance",
                label: "Opening Balance",
                type: "number",
              },
              {
                id: Math.random() * 10,
                name: "Credit_Or_Debit",
                label: "Cr/Db",
                type: "inputdrop",
                dropdowncontent: ["Cr", "Db"],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Documents",
    label: "Other Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Aadhar_Card",
        label: "Aadhar Card",
      },
      {
        id: Math.random() * 10,
        name: "Pan_Card",
        label: "Pan Card",
      },
      {
        id: Math.random() * 10,
        name: "Proprietor_Photo",
        label: "Proprietor Photo",
      },
      {
        id: Math.random() * 10,
        name: "Visiting_Card",
        label: "Visiting Card",
      },
      {
        id: Math.random() * 10,
        name: "GST_Certificate",
        label: "GST Certificate",
      },
      {
        id: Math.random() * 10,
        name: "Shop_Act_Licence",
        label: "Shop Act Licence",
      },
      {
        id: Math.random() * 10,
        name: "Office_Board_Photo",
        label: "Office Board Photo",
      },
      {
        id: Math.random() * 10,
        name: "MSME_certificate",
        label: "MSME certificate",
      },
      {
        id: Math.random() * 10,
        name: "Self_Declaration_video",
        label: "Self Declaration video",
      },
      {
        id: Math.random() * 10,
        name: "Other_Doc_1",
        label: "Other Doc 1",
      },
      {
        id: Math.random() * 10,
        name: "Other_Doc_2",
        label: "Other Doc 2",
      },
    ],
  },
];

export const controlData = [
  {
    name: "Controls",
    fields: [
      {
        id: Math.random() * 10,
        name: "Is_Verified",
        label: "Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Is_Document_Verified",
        label: "Document Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Is_Lock",
        label: "Lock ",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Is_Mobile_Number_Verified",
        label: "Mobile Number Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Is_Email_Verified",
        label: "Email Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },

      {
        id: Math.random() * 10,
        name: "Is_Aadhar_Verified",
        label: "Aadhar Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Is_Pan_Verified",
        label: "Pan Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Is_Gst_Verified",
        label: "GST Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Is_Bank_Verified",
        label: "Bank Verified ",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "KYC_Complete",
        label: "Kyc Complete",
        type: "checkbox",
        min: 0,
        max: Infinity,
        disabled: true,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "CreateCSUser",
      //   label: "Create CS User",
      //   type: "checkbox",
      //   min: 0,
      //   max: Infinity,
      //   disabled: false,
      // },
    ],
  },
];

export const CustomerRemarksData = {
  Is_Verified: {
    id: Math.random() * 10,
    name: "Verified_Remark",
    label: "Remarks",
    type: "textarea",
    FirstCharCap: true,
  },
};

export const DefaultConfiguration = [
  {
    id: Math.random() * 10,
    name: "Config_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "accountgroups",
        label: "Default Account Group ",
        masterName: "Account_Group",
        type: "InputDropForQuery",
      },
    ],
  },
];
